module.exports = __webpack_public_path__ + "static/media/varal-1@8b75porc.7e521478.png";